const routes = {
  // WELCOME: "/", (uncomment when use home page)
  TOURISM: "/",
  ATRACTIVES: "/tourism-atractives",
  ATRACTIVE_DETAIL: "/tourism-atractive-detail/:id",
  SERVERS: "/tourism-servers",
  SERVER_DETAIL: "/tourism-server-detail/:id",
  TROUTES: "/tourism-routes",
  TROUTE_DETAIL: "/tourism-route-detail/:id",
  PAYMENTS: "/services/payments",
  TRANSPORT: "/tourism-transport",
  EVENTS: "/events",
};

export default routes;
